/**
 * PDF renderer using browser's built-in PDF viewer via object/iframe
 */

import { useState } from 'react';
import { Box, Stack, Text } from '@mantine/core';
import { IconFileTypePdf } from '@tabler/icons-react';

interface PdfRendererProps {
  src: string;
  title: string;
}

export function PdfRenderer({ src, title }: PdfRendererProps) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <Stack align="center" justify="center" h="100%" gap="md">
        <IconFileTypePdf size={48} color="var(--mantine-color-red-5)" />
        <Text c="dimmed" size="sm">Unable to preview PDF</Text>
        <Text
          component="a"
          href={src}
          target="_blank"
          rel="noopener noreferrer"
          size="sm"
          c="blue.4"
          style={{ textDecoration: 'underline', cursor: 'pointer' }}
        >
          Open in new tab
        </Text>
      </Stack>
    );
  }

  return (
    <Box style={{ width: '100%', height: '100%', padding: 8 }}>
      <object
        data={src}
        type="application/pdf"
        title={title}
        style={{
          width: '100%',
          height: '100%',
          borderRadius: 8,
          backgroundColor: 'white',
        }}
      >
        {/* Fallback iframe if object fails */}
        <iframe
          src={src}
          title={title}
          onError={() => setFailed(true)}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            borderRadius: 8,
            backgroundColor: 'white',
          }}
        />
      </object>
    </Box>
  );
}
